import type { ExpenseDocument } from '@peles/shared';
import { apiClient } from './client';

export interface CompareQuoteItem {
  id: string;
  vendorName: string | null;
  vendorCategoryName: string;
  price: number;
  statusName: string;
  statusColor: string | null;
  totalPaid: number;
  balance: number;
  comments: string | null;
  dueDate: Date | null;
  itemName: string | null;
  documents: Array<{
    id: string;
    fileName: string;
    mimeType: string;
    fileSizeBytes: number;
    type: string;
    createdAt: Date;
  }>;
  createdAt: Date;
}

export async function listExpenseDocuments(expenseItemId: string): Promise<ExpenseDocument[]> {
  const { data } = await apiClient.get<ExpenseDocument[]>(`/expenses/${expenseItemId}/documents`);
  return data;
}

export async function addExpenseDocument(
  expenseItemId: string,
  doc: {
    s3Key: string;
    fileName: string;
    mimeType: string;
    fileSizeBytes: number;
    type?: string;
  },
): Promise<ExpenseDocument> {
  const { data } = await apiClient.post<ExpenseDocument>(
    `/expenses/${expenseItemId}/documents`,
    doc,
  );
  return data;
}

export async function removeExpenseDocument(expenseItemId: string, docId: string): Promise<void> {
  await apiClient.delete(`/expenses/${expenseItemId}/documents/${docId}`);
}

export async function getDocumentDownloadUrl(
  expenseItemId: string,
  docId: string,
): Promise<string> {
  const { data } = await apiClient.get<{ downloadUrl: string }>(
    `/expenses/${expenseItemId}/documents/${docId}/url`,
  );
  return data.downloadUrl;
}

export async function compareQuotes(
  eventId: string,
  categoryId: string,
): Promise<CompareQuoteItem[]> {
  const { data } = await apiClient.get<CompareQuoteItem[]>('/expenses/compare', {
    params: { eventId, categoryId },
  });
  return data;
}
